import { FC } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';

import Block from '../../components/Block';
import Column from '../../components/Column';
import Heading from '../../components/Heading';
import Row from '../../components/Row';
import { PrintContext } from '../../hooks/usePrint';
import { HatDashboardPageProvider, useHatDashboardPage } from '../../hooks/Pages/HatDashboardPage';
import usePrint from '../../hooks/usePrint';
import HatCriteriaForm from './partials/HatCriteriaForm';
import HatMediaTabs from './partials/Tabs/HatMediaTabs';

import HatExportMenuButton from './partials/Exports/HatExportMenuButton';
import HatMetrics from './partials/HatMetrics';
import HatChannelByChannelPieChartCard from './partials/Charts/HatChannelByChannelPieChartCard';
import HatConversionByActionPieChartCard from './partials/Charts/HatConversionByActionPieChartCard';
import HatPerformanceChartLineCard from './partials/Charts/HatPerformanceChartLineCard';
import HatChannelTrafficTableView from './partials/Views/HatChannelTrafficTableView';
import HatConversionTrafficTableView from './partials/Views/HatConversionTrafficTableView';
import { AttributionPageProvider, useAttributionPage } from '../../hooks/useAttributionPage';

const HatDashboardPage: FC = (): React.JSX.Element => {
    const theme = useTheme();
    const print = usePrint();
    const hatDashboardPage = useHatDashboardPage();
    const attributionPage = useAttributionPage();

    const { hatCriteria, setHatCriteria, mediaTabs } = hatDashboardPage;

    return (
        <PrintContext.Provider value={print}>
            <HatDashboardPageProvider value={hatDashboardPage}>
                <Column gap={0} flex={1}>
                    <Block>
                        <Column gap={1}>
                            <Row spacing={2} justifyContent="space-between" alignItems="center">
                                <Heading>HAT Reporting</Heading>

                                <Row justifyContent="flex-end"></Row>
                            </Row>
                        </Column>
                    </Block>

                    <Block py={0}>
                        <Row spacing={2} justifyContent="space-between" alignItems="center">
                            <Row spacing={2} alignItems="center">
                                <Box
                                    sx={{
                                        '&': {
                                            width: '100%',

                                            [theme.breakpoints.up('xl')]: {
                                                width: 1200,
                                            },
                                        },
                                    }}
                                >
                                    <HatCriteriaForm criteria={hatCriteria} onChangeCriteria={setHatCriteria} />
                                </Box>
                            </Row>

                            <Button
                                variant="outlined"
                                color="primary"
                                size="medium"
                                component={Link}
                                to="https://app.trialfire.com"
                                target="_blank"
                            >
                                Advanced Reporting
                            </Button>
                        </Row>
                    </Block>

                    <Block disableGutters>
                        <HatMediaTabs value={mediaTabs.activeTab} onChange={mediaTabs.handleChangeTab} />
                    </Block>

                    <Block>
                        <Column>
                            <Column>
                                <Row justifyContent="space-between">
                                    <Row flex={1} width="100%">
                                        <Typography variant="h6">Performance</Typography>
                                    </Row>

                                    <Row width="auto">
                                        <AttributionPageProvider value={attributionPage}>
                                            <HatExportMenuButton disabled={false} />
                                        </AttributionPageProvider>

                                        {/*{hatCriteria.advertiserId && (
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                component={Link}
                                                to={`/advertisers/${hatCriteria.advertiserId}`}
                                            >
                                                Customize
                                            </Button>
                                        )}*/}
                                    </Row>
                                </Row>

                                <HatMetrics />

                                <HatPerformanceChartLineCard />
                            </Column>

                            <Column>
                                <Typography variant="h6">Visits</Typography>

                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <HatChannelByChannelPieChartCard />
                                    </Grid>

                                    <Grid item md={6} xs={12}>
                                        <HatChannelTrafficTableView />
                                    </Grid>
                                </Grid>
                            </Column>

                            <Column>
                                <Typography variant="h6">Actions</Typography>

                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <HatConversionByActionPieChartCard />
                                    </Grid>

                                    <Grid item md={6} xs={12}>
                                        <HatConversionTrafficTableView />
                                    </Grid>
                                </Grid>
                            </Column>
                        </Column>
                    </Block>
                </Column>
            </HatDashboardPageProvider>
        </PrintContext.Provider>
    );
};

export default HatDashboardPage;
